// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5fa4ae51","455":"c6934c9d","977":"e4509d20"}[chunkId] + ".chunk.js";
};